/* 記事本文中で紹介した「商品」「他記事」を、そのH2/H3セクション末尾にカード表示する。
   商品: /products/{handle} → /products/{handle}.js からライブ取得（価格・画像は常に最新）
   記事: /blogs/{blog}/{handle} → 記事ページの og:title / og:image / 公開日を取得
   記事リンクが複数の場合は記事末に全件を横並びで再掲。
   カードは「出現順」を保つため、プレースホルダを先に配置してからデータを流し込む。 */
(function () {
  function init() {
    var content = document.querySelector('.article-template__content');
    if (!content) return;
    var currentPath = location.pathname.replace(/\/+$/, '');
    var links = Array.prototype.slice.call(content.querySelectorAll('a[href*="/products/"], a[href*="/blogs/"]'));
    if (!links.length) return;

    var groups = [];
    function groupFor(anchorEl, type) {
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].anchorEl === anchorEl && groups[i].type === type) return groups[i];
      }
      var g = { anchorEl: anchorEl, type: type, keys: [] };
      groups.push(g);
      return g;
    }
    links.forEach(function (a) {
      if (a.closest && a.closest('.ts-inline-products')) return;
      if (a.classList && a.classList.contains('ts-xlink')) return; // 本文内部リンク(SEO用)はカード化しない
      var href = a.getAttribute('href') || '';
      var type, key;
      var pm = href.match(/\/products\/([^\/?#]+)/);
      var am = href.match(/\/blogs\/([^\/?#]+)\/([^\/?#]+)/);
      if (pm) { type = 'product'; key = pm[1]; }
      else if (am) {
        if (href.indexOf('/tagged/') >= 0) return;
        type = 'article'; key = am[1] + '/' + am[2];
        try { var u = new URL(a.href, location.origin); if (u.pathname.replace(/\/+$/, '') === currentPath) return; } catch (e) {}
      } else return;

      var block = a;
      while (block.parentElement && block.parentElement !== content) { block = block.parentElement; }
      if (block.parentElement !== content) return;
      var el = block.nextElementSibling, anchorEl = null;
      while (el) {
        if (el.tagName === 'H2' || el.tagName === 'H3') { anchorEl = el; break; }
        el = el.nextElementSibling;
      }
      var g = groupFor(anchorEl, type);
      if (g.keys.indexOf(key) === -1) g.keys.push(key);
    });

    groups.forEach(function (g) {
      if (!g.keys.length) return;
      var wrap = document.createElement('div');
      wrap.className = 'ts-inline-products' + (g.type === 'article' ? ' ts-inline-products--articles' : '');
      if (g.anchorEl) { g.anchorEl.parentNode.insertBefore(wrap, g.anchorEl); }
      else { content.appendChild(wrap); }
      var label = g.type === 'product' ? 'この章で紹介した器' : 'あわせて読みたい記事';
      g.keys.forEach(function (key) {
        if (g.type === 'product') buildProductCard(wrap, key, label);
        else buildArticleCard(wrap, key, label);
      });
    });

    // 記事末: 記事リンクが複数あった場合、登場した記事を全件まとめて横並びで再掲（出現順）
    var allArticleKeys = [];
    groups.forEach(function (g) {
      if (g.type !== 'article') return;
      g.keys.forEach(function (k) { if (allArticleKeys.indexOf(k) === -1) allArticleKeys.push(k); });
    });
    if (allArticleKeys.length >= 2) {
      var summary = document.createElement('div');
      summary.className = 'ts-inline-products ts-inline-products--articles ts-inline-products--summary';
      content.appendChild(summary);
      allArticleKeys.forEach(function (key) { buildArticleCard(summary, key, 'あわせて読みたい記事'); });
    }
  }

  function money(cents) {
    var n = Math.round((cents || 0) / 100);
    try { return '¥' + n.toLocaleString('ja-JP'); } catch (e) { return '¥' + n; }
  }
  function esc(s) {
    return (s || '').replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function sizedImg(url, w) {
    if (!url) return '';
    url = url.replace(/^http:/, 'https:');
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }
  function ensureLabel(wrap, text) {
    if (!text || wrap.querySelector('.ts-inline-products__label')) return;
    var label = document.createElement('div');
    label.className = 'ts-inline-products__label';
    label.textContent = text;
    wrap.insertBefore(label, wrap.firstChild);
  }
  // 出現順を保つため、空カードを先に配置して返す
  function placeholder(wrap, label, href, extraClass) {
    ensureLabel(wrap, label);
    var card = document.createElement('a');
    card.className = 'ts-ipc is-loading' + (extraClass ? ' ' + extraClass : '');
    card.href = href;
    wrap.appendChild(card);
    return card;
  }
  function drop(card) {
    var wrap = card.parentNode;
    if (wrap) wrap.removeChild(card);
    if (wrap && !wrap.querySelector('.ts-ipc') && wrap.parentNode) wrap.parentNode.removeChild(wrap);
  }

  function buildProductCard(wrap, handle, label) {
    var card = placeholder(wrap, label, '/products/' + handle);
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        var img = sizedImg(p.featured_image || (p.images && p.images[0]) || '', 440);
        var priceHtml = money(p.price) + '<span class="ts-ipc__tax">（税込）</span>';
        if (p.compare_at_price && p.compare_at_price > p.price) {
          priceHtml = '<span class="ts-ipc__was">' + money(p.compare_at_price) + '</span>' + priceHtml;
        }
        var btn = p.available ? '商品を見る <span aria-hidden="true">→</span>' : '在庫切れ';
        card.innerHTML =
          '<span class="ts-ipc__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" decoding="async">' : '') + '</span>' +
          '<span class="ts-ipc__body">' +
            '<span class="ts-ipc__name">' + esc(p.title) + '</span>' +
            '<span class="ts-ipc__price">' + priceHtml + '</span>' +
            '<span class="ts-ipc__btn' + (p.available ? '' : ' is-sold') + '">' + btn + '</span>' +
          '</span>';
        card.classList.remove('is-loading');
      })
      .catch(function () { drop(card); });
  }

  function buildArticleCard(wrap, key, label) {
    var card = placeholder(wrap, label, '/blogs/' + key, 'ts-ipc--article');
    fetch('/blogs/' + key, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        function meta(p) { var m = doc.querySelector('meta[property="' + p + '"]'); return m ? m.getAttribute('content') : ''; }
        var title = meta('og:title') || (doc.querySelector('title') ? doc.querySelector('title').textContent : key);
        var img = sizedImg(meta('og:image'), 440);
        var date = meta('article:published_time');
        var dateStr = '';
        if (date) { var d = new Date(date); if (!isNaN(d.getTime())) dateStr = d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日'; }
        card.innerHTML =
          '<span class="ts-ipc__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" decoding="async">' : '') + '</span>' +
          '<span class="ts-ipc__body">' +
            '<span class="ts-ipc__name">' + esc(title) + '</span>' +
            (dateStr ? '<span class="ts-ipc__date">' + dateStr + '</span>' : '') +
            '<span class="ts-ipc__btn">記事を読む <span aria-hidden="true">→</span></span>' +
          '</span>';
        card.classList.remove('is-loading');
      })
      .catch(function () { drop(card); });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
